import React from 'react'
import TimeCounter from "./TimeCounter/TimeCounter"
import { getAnalysisStatus, getAnalysisStatusColor } from "../../utils/utils"

function TimerBox (props) {
    let {bankslip} = props
    if(bankslip.analysis_status === "pending" || bankslip.analysis_status === "in_manual_analysis"){
        return (
            <TimeCounter bankslip={bankslip}/>
        )
    }
    else{
        return(
            <div className="analysisCard" style={{height:"100%", borderWidth:"1px", borderStyle:"solid", borderColor:getAnalysisStatusColor(bankslip.analysis_status)}}>
                <div 
                    className={["normalText", "substitleSize", "bold"].join(" ")} 
                    style={{margin:"auto", color:getAnalysisStatusColor(bankslip.analysis_status)}}
                >
                    {getAnalysisStatus(bankslip.analysis_status)}                    
                </div>
            </div>
        )
    }
}

export default TimerBox